import { request } from './axios.config';

export const common = {
    async uploadImage(file: File | Blob): Promise<string> {
        const data = new FormData();
        data.append('file', file);

        const res = await request.post<{ url: string; }>('/upload/image', data);
        return res.url;
    },
    sendTestEmail(data: { toEmail: string; subject: string; html: string; text: string; }) {
        return request.post('/emailtemplate/sendtestemail', {
            toEmail: data.toEmail,
            subject: data.subject,
            body: data.html,
        });
    },
};

export interface IAppMenuItem {
    name: string;
    url?: string;
    icon: string;
    isOpen?: boolean;
    children: IAppSubMenuItem[];
}

export interface IAppSubMenuItem {
    name: string;
    url: string;
    isOpen?: boolean;
}
